import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/dateTimeField.scss';
import { useEffect, useRef } from 'react';
import { DateSectionType, SECTION_MAX_LENGTH, SECTION_PLACEHOLDERS, SECTION_RANGES } from './dateTimeConstants';
import { Typography } from '../Typography/Typography';
function getDisplayText(type, value) {
    const resolvedPlaceholder = SECTION_PLACEHOLDERS[type];
    const resolvedMaxLength = SECTION_MAX_LENGTH[type];
    if (value === null || Number.isNaN(value)) {
        return resolvedPlaceholder;
    }
    if (type === DateSectionType.YYYY) {
        return String(value).padStart(resolvedMaxLength, '0');
    }
    return String(value).padStart(2, '0');
}
export const DateSection = ({ type, value, selected, disabled = false, onSelect, onDigitInput, onPaste, onIncrement, onDecrement, onNavigateLeft, onNavigateRight, onDelete }) => {
    const spanRef = useRef(null);
    const resolvedRange = SECTION_RANGES[type];
    const displayText = getDisplayText(type, value);
    const selectText = () => {
        if (spanRef.current) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(spanRef.current);
            selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
            selection === null || selection === void 0 ? void 0 : selection.addRange(range);
        }
    };
    useEffect(() => {
        if (selected) {
            selectText();
        }
    }, [selected]);
    const handleKeyDown = (event) => {
        if (disabled) {
            return;
        }
        const key = event.key;
        if (/^\d$/.test(key)) {
            event.preventDefault();
            onDigitInput(key);
            return;
        }
        switch (key) {
            case 'ArrowUp':
                event.preventDefault();
                onIncrement();
                return;
            case 'ArrowDown':
                event.preventDefault();
                onDecrement();
                return;
            case 'ArrowLeft':
                event.preventDefault();
                onNavigateLeft();
                return;
            case 'ArrowRight':
                event.preventDefault();
                onNavigateRight();
                return;
            case 'Backspace':
            case 'Delete':
                event.preventDefault();
                onDelete();
                return;
            default:
                return;
        }
    };
    const handlePaste = (event) => {
        event.preventDefault();
        const pastedText = event.clipboardData.getData('text');
        const digits = pastedText.replace(/\D/g, '');
        if (digits.length > 0) {
            onPaste(digits);
        }
    };
    const handleInput = (event) => {
        event.preventDefault();
        const target = event.target;
        target.textContent = displayText;
        selectText();
    };
    const handleClick = () => {
        if (disabled) {
            return;
        }
        onSelect();
        selectText();
    };
    const classNames = ['date-time-field-section', selected ? 'selected' : null, disabled ? 'disabled' : null]
        .filter(Boolean)
        .join(' ');
    return (_jsx(_Fragment, { children: _jsx(Typography, { ref: spanRef, role: "spinbutton", tabIndex: disabled ? -1 : 0, "aria-label": type, "aria-valuemin": resolvedRange.min, "aria-valuemax": resolvedRange.max, "aria-disabled": disabled, contentEditable: !disabled, suppressContentEditableWarning: true, spellCheck: false, autoCapitalize: "none", autoCorrect: "off", inputMode: "numeric", className: classNames, onClick: handleClick, onKeyDown: handleKeyDown, onInput: handleInput, onPaste: handlePaste, children: displayText }) }));
};
